import React, { PropsWithChildren, useContext } from 'react';
import { SyncCoreApiContext } from '../contexts/SyncCoreApiContext';
import { getCurrentSiteUuid } from '../services/SyncCoreApiComponent';
import { MissingSiteAlert } from './MissingSiteAlert';

interface IProps extends PropsWithChildren {}

export function RequireCurrentSite({ children }: IProps) {
  const apiContext = useContext(SyncCoreApiContext);
  const siteUuid = getCurrentSiteUuid(apiContext?.jwt);

  if (!siteUuid) {
    return <MissingSiteAlert />;
  }

  return <>{children}</>;
}
